<template>
    <transition name="slide-fade">
        <div class="carousel-item"
            v-show="currentSlide === index" >

             <picture>
              <source :srcset="slidesm1[index]" media="(max-width: 450px)">
              <source :srcset="slide">
               <img :src="slide" :alt="`img-${index}`"/>
            </picture>
            <div class="hero-header el">
              <h1 class="h-main fadesideuvod tricks">
                <div v-if="index === 0">
                  <span class="tricksword sec"><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">B</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">L</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">A</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">C</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">K</span></span>
                  <span class="tricksword sec"><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">F</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">R</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">I</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">D</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">A</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">Y</span></span>
                </div>

                <div v-else-if="index === 1">
                  <span class="tricksword fir"><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">S</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">K</span></span>
                <span class="tricksword fir"><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">M</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">E</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">T</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">A</span><span class="letter" style="transform: translateX(0px) translateZ(0px); opacity: 1;">L</span></span>
                </div>
              </h1>
              <p class="slide-in-bottom">{{text}}</p>              
            </div>
            <div class="hero-header en">
              <h3 class="slide-in-bottom">{{title}}</h3>
              <p class="slide-in-bottom">{{texten}}</p>              
            </div>
             
        </div> 
    </transition>
</template>
<script>

export default {
  props: ['slide', "currentSlide", "index","title","text", "texten"],
  methods: {
    /*drag2(event){
     event.preventDefault();
    },*/
  },
  data: () => ({
    slidesm1: [
     "/wp-content/uploads/2024/10/welding-1.webp",
     "/wp-content/uploads/2024/10/HERO2-1.webp",
    ],
  }),
}

</script>

<style>

.buttons-outline{
  display: flex;
}
.btn-outline {
  border: 2px solid black;
  background-color: white;
  color: black;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
}

/* Green */
.color-outline {
  border-color: #04AA6D;
  color: green;
}

.color-outline:hover {
  background-color: #04AA6D;
  color: white;
}
.hero-header {
    box-shadow: -2px 2px 12px rgb(0 0 0 / 17%);
    backdrop-filter: blur(4px);
    border-radius: 20px;
    padding: 40px;
}
/*.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}*/
.carousel-item img{
  width: 100% !important;
}
</style>